export default __webpack_public_path__ + "static/media/project_shot_east_douglas_4.991d3034.jpg";